import datas from './datas'

export default
{
    datas
};
